<template>
  <div>
    <div v-if="workShow === 'list'">
      <div class="commonFilter">
        <div class="card-container">
          <div class="card-content">
            <Form ref="pageParams" :model="pageParams" :label-width="90" label-position="right">
              <div class="platformSearch">
                <!-- 状态 -->
                  <Form-item :label="$t('common.status') + '：'">
                    <keep-alive>
                      <Button-group>
                        <template v-for="(item, index) in isValidList">
                          <Button v-if="item.selected" type="primary" @click="getIsValidStatus(index,item.id)" :key="index">{{item.title}}</Button>
                          <Button v-if="!item.selected" @click="getIsValidStatus(index,item.id)" :key="index">{{item.title}}</Button>
                        </template>
                      </Button-group>
                    </keep-alive>
                  </Form-item>
                  <Row>
                    <Col span="5">
                      <Form-item :label="$t('logisticsProvider.warehouseCode') + '：'">
                        <Input v-model.trim="pageParams.warehouseCode"></Input>
                      </Form-item>
                    </Col>
                    <Col span="5">
                      <Form-item :label="$t('logisticsProvider.warehouseName') + '：'">
                        <Input v-model.trim="pageParams.warehouseName"></Input>
                      </Form-item>
                    </Col>
                    <Col span='3' style="margin-left:62px;">
                      <Button type="primary" v-once icon="search" @click="search">{{$t('common.search')}}</Button>
                    </Col>
                  </Row>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <!--操作区-->
      <div class="addCanal">
        <Button type="primary" @click="addCanalFn" icon="plus">{{ $t('logisticsProvider.addCanal') }}</Button>
      </div>
      <!-- 列表 -->
      <div class="orderTable normalTop">
        <Table highlight-row border :columns="canalColumns" :height="tableHeight" :data="canalData"></Table>
        <div class="table-page">
          <div class="table-page-right">
            <Page :total="total" @on-change="changePage" show-total :page-size="pageParams.pageSize" show-elevator :current="pageParams.pageNum" show-sizer @on-page-size-change="changePageSize" placement="top" :page-size-opts="pageArray"></Page>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增和编辑渠道 -->
    <warehouseDetail :tmpwarehouseId="tmpwarehouseId" :addFlag="addFlag" v-if="workShow === 'detail'"></warehouseDetail>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
import warehouseDetail from './warehouseDetail';
export default {
  mixins: [ Mixin, tableMixin ],
  components: {
    warehouseDetail
  },
  data () {
    let self = this;
    return {
      workShow: 'list',
      addFlag: '', // 新增标识
      tmpwarehouseId: '',
      pageParamsStatus: false, // 每次更新完pageParms都要设置成true触发刷新
      pageParams: {
        warehouseStatus: null, // 启用状态（选全部传空，1：是，0：否）
        checkStatus: null, // 是否审核通过（0-未通过1-通过2-拒绝）
        pageNum: 1,
        pageSize: 10,
        warehouseName: null, // 仓库名称
        warehouseCode: null // 仓库代码
      },
      isValidList: [ // 状态
        {
          title: self.t('common.all'),
          id: null,
          selected: true
        },
        {
          title: self.t('common.status1'),
          id: 1,
          selected: false
        },
        {
          title: self.t('common.status0'),
          id: 0,
          selected: false
        },
        {
          title: self.t('common.checkstatus0'),
          id: 2,
          selected: false
        }
      ],
      canalColumns: [
        {
          title: self.t('common.serialNum'),
          type: 'index',
          width: 70,
          fixed: 'left',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.warehouseName'),
          key: 'warehouseName',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.warehouseCode'),
          key: 'warehouseCode',
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.country'),
          key: 'countryCode',
          minWidth: 150,
          maxWidth: 300,
          align: 'center'
        },
        {
          title: self.t('common.status'),
          key: 'status',
          align: 'center',
          render (h, params) {
            return params.row.status === '1'
              ? h('span', {
                style: {
                  color: '#3cb034'
                }
              }, self.t('common.status1'))
              : h('span', {
                style: {
                  color: '#de2910'
                }
              }, self.t('common.status0'));
          }
        },
        {
          title: self.t('common.checkStatus'),
          key: 'checkStatus',
          align: 'center',
          render (h, params) {
            return params.row.checkStatus === 1
              ? h('span', {
                style: {
                  color: '#3cb034'
                }
              }, self.t('common.checkstatus1')
              )
              : (params.row.checkStatus === 2
                ? h('span', {
                  style: {
                    color: '#de2910'
                  }
                }, self.t('common.checkstatus2'))
                : h('span', {
                  style: {
                    color: '#F7BF00'
                  }
                }, self.t('common.checkstatus0')));
          }
        },
        {
          title: self.t('common.operation'),
          width: 150,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    self.tmpwarehouseId = params.row.warehouseId; // 仓库ID
                    self.addFlag = 'edit';
                    self.workShow = 'detail';
                  }
                }
              }, self.t('common.edit')),
              params.row.status === '1'
                ? h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginLeft: '5px'
                  },
                  on: {
                    click: () => {
                      self.changeStatus(params.row.warehouseId, params.row.status);
                    }
                  }
                }, self.t('common.status0'))
                : h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginLeft: '5px'
                  },
                  on: {
                    click: () => {
                      self.changeStatus(params.row.warehouseId, params.row.status);
                    }
                  }
                }, self.t('common.status1'))
            ]);
          }
        }
      ],
      canalData: [],
      total: 0, // 总记录数
      canalDetailModal: false // 是否显示选择映射sku模态窗
    };
  },
  methods: {
    getIsValidStatus (index, id) { // 状态筛选
      let v = this;
      if (id === 2) {
        v.pageParams.checkStatus = 0;
        v.pageParams.warehouseStatus = null;
      } else {
        v.pageParams.checkStatus = null;
        v.pageParams.warehouseStatus = id;
      }

      v.isValidList.forEach((n, i) => {
        if (i === index) {
          n.selected = true;
        } else {
          n.selected = false;
        }
      });
      v.getList();
    },
    search () { // 查询
      let v = this;
      v.pageParamsStatus = true;
      v.pageParams.pageNum = 1;
    },
    // 新增渠道
    addCanalFn () {
      let v = this;
      v.$nextTick(function () {
        v.tmpwarehouseId = '';
        v.addFlag = 'add';
        v.workShow = 'detail';
      });
    },
    // 获取渠道列表数据
    getList () {
      let v = this;
      if (v.pageParams.warehouseName === '') {
        v.pageParams.warehouseName = null;
      }
      if (v.pageParams.warehouseCode === '') {
        v.pageParams.warehouseCode = null;
      }
      v.axios.post(api.warehouse_getList, v.pageParams)
        .then(res => {
          if (res.data.code === 0) {
            v.canalData = res.data.datas.list;
            v.total = res.data.datas.total;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 修改渠道状态
    changeStatus (warehouseId, isValid) {
      let v = this;
      debugger;
      if (isValid === '1') {
        isValid = 0;
      } else {
        isValid = 1;
      }
      let objParams = {
        warehouseId: warehouseId, // 仓库ID
        status: isValid // 仓库名称
      };

      v.axios.post(api.warehouse_modifyStatus, objParams)
        .then(res => {
          if (res.data.code === 0) {
            v.pageParamsStatus = true;
            if (isValid === 1) {
              v.$Message.success(v.t('common.enableOk'));
            } else if (isValid === 0) {
              v.$Message.success(v.t('common.disableOk'));
            }
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    }
  },
  created () {
    let v = this;
    v.getList();
    v.tableHeight = v.getTableHeight(448);
  },
  watch: {
    pageParamsStatus (n) {
      let v = this;
      if (n) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/warehouseInfo.vue